/** @format */

import Moment from 'moment';
import SuperAgent from 'superagent';

const allSizesStorageKey = 'all-sizes-1';

// This version number can be used to cache bust the sizes currently in localStorage.
// Increment this if you make changes in here so browsers will be forced to pull down the
// latest sizes.
const allSizesClientVersion = 9;

const setSizesLocal = sizes => {
    const val = {
        lastModified: Moment().utc().format('YYYY-MM-DD HH:mm:ss'),
        clientVersion: allSizesClientVersion,
        sizes
    };
    localStorage.setItem(allSizesStorageKey, JSON.stringify(val));
    return val;
};

const getSizesLocal = () => {
    const localStorageItem = localStorage.getItem(allSizesStorageKey);
    const results = {sizes: [], lastModified: '', clientVersion: 0};

    if (localStorageItem) {
        try {
            const data = JSON.parse(localStorageItem);

            // If the stored version doesn't match our client version, return the empty
            // results with an empty lastModified so we'll re-fetch.
            if (data.clientVersion != allSizesClientVersion) {
                return results;
            }

            results.sizes = data.sizes;
            results.lastModified = data.lastModified;
            results.clientVersion = allSizesClientVersion;
        } catch (e) {
            return results;
        }
    }

    return results;
};

const fetchAllSizes = async () => {
    const cachedSizes = getSizesLocal();

    try {
        const response = await SuperAgent.post('/admin/sizes/see-all-sizes')
            .set('accept', 'application/json')
            .send({lastModified: cachedSizes.lastModified});

        const {sizes} = response.body;

        // Reduce storage size by storing only a slice of each die's properties.
        // LocalStorage has a storage limit and this payload is quite large as
        // uncompressed JSON. Consider bringing in the library LZString to compress
        // the JSON if the list of dies continues to grow.
        //
        // IMPORTANT: if you change this, bump allSizesClientVersion.
        const mappedSizes = sizes.map(
            ({
                id,
                status_id,
                width,
                length,
                label,
                depth,
                shape_id,
                is_square_corners,
                size_type_id,
                product_type_id,
                s3key
            }) => ({
                id,
                status_id,
                width,
                length,
                depth,
                label,
                shape_id,
                is_square_corners,
                size_type_id,
                product_type_id,
                s3key
            })
        );

        return setSizesLocal(mappedSizes);
    } catch (e) {
        if (e.message.includes('Not Modified')) {
            return cachedSizes;
        } else {
            console.error(e); // TODO: report this to bug tracker?
            return cachedSizes; // Return this anyway, even though it may be empty
        }
    }
};

export {setSizesLocal, getSizesLocal, fetchAllSizes};
